<div fxLayout="column" fxLayoutGap="10px" >
  <h2 id="title" class="page-header" fxFill>Descarga de Archivos</h2>
  <form fxLayout="column" style="margin: 2.5rem" [formGroup]="vehRemitosPrintedForm" #formDirective="ngForm" autocomplete="off">
    <div id="searchButton" fxLayout="column">
      <div style="text-align:right;">
        <button mat-icon-button class="view-remito-buttons" (click)="search()"><mat-icon>pageview</mat-icon></button>
      </div>
    </div>

    <mat-divider class="mat-divider-header"></mat-divider>
    <div id="searchFieldsRow" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap.gt-sm="1rem" fxLayoutGap.lt-md="0">
      <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
        <mat-label>Nombre</mat-label>
        <input type="text" matInput [formControl]="nombreControl" [matAutocomplete]="autoNombre">
        <mat-autocomplete #autoNombre="matAutocomplete">
          <mat-option *ngFor="let nombre of filteredNombre | async"
                      [value]="nombre.desc">
            {{ nombre.desc }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field fxFlex.gt-sm="23%" fxFlex.sm="39%" fxFlex.lt-sm="100%" appearance="outline">
        <mat-label>Fecha</mat-label>
        <input matInput [matDatepicker]="fecha" [formControl]="fechaControl">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="fecha"></mat-datepicker-toggle>
        <mat-datepicker #fecha></mat-datepicker>
      </mat-form-field>
    </div>

  </form>

  <!-- Table -->
  <div class="table-height" style="flex-direction: column;display: flex;" *ngIf="showVehRemData">
    <table mat-table matSort [dataSource]="dataSource">

      <!-- Nombre Column -->
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre
          <fab-string-filter #tableFilter columnDef="nombre" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element">  {{ element.nombre }} </td>
      </ng-container>

      <!-- Fecha Column -->
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha
          <fab-date-filter #tableFilter columnDef="fecha" [operators]="dateOperators" (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.fecha | date:'dd/MM/yyyy HH:mm:ss'}} </td>
      </ng-container>

      <!-- Tamaño Column -->
      <ng-container matColumnDef="tamano">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tamaño
          <fab-string-filter #tableFilter columnDef="tamano" [operators]="operators" (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell  class="center" *matCellDef="let element"> {{element.tamano+"M"}} </td>
      </ng-container>

      <!-- Impresoras Column -->
      <ng-container matColumnDef="impresoras">
        <th mat-header-cell *matHeaderCellDef> Impresoras</th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <mat-form-field appearance="standard">
            <mat-label>Select Impresoras</mat-label>
            <input matInput [(ngModel)]="element.impresoras" [matAutocomplete]="autoImpresoras"
                   (ngModelChange)="onChangeImpresoras(element)">
            <mat-autocomplete #autoImpresoras="matAutocomplete" >
              <mat-option *ngFor="let impresoras of impresorasFiltering(element.impresoras)"
                          [value]="impresoras.id + ' - ' + impresoras.desc">
                {{impresoras.id}} - {{impresoras.desc}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-error *ngIf="element.isInvalid">Seleccione un Impresora</mat-error>
        </td>
      </ng-container>

      <!-- Send Button Column -->
      <ng-container matColumnDef="sendButton">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element"  class="left">
          <button mat-icon-button class="view-remito-buttons" (click)="sendPrintedRemito(element)">
            <mat-icon>email</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <mat-paginator #paginator
                 [pageSize]="10"
                 [pageSizeOptions]="[10, 15, 20, 25]"
                 [hidden]="!dataSource.data.length">
  </mat-paginator>

</div>
